import { render } from "./navBarKyc.vue?vue&type=template&id=20184246"
import script from "./navBarKyc.vue?vue&type=script&lang=js"
export * from "./navBarKyc.vue?vue&type=script&lang=js"

import "./navBarKyc.vue?vue&type=style&index=0&id=20184246&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__